import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 0.5fr',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    },
    alignItems: 'center',
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 12,
    margin: '8px 0'
  },
  title: {
    fontWeight: 600,
    fontSize: 14
  },
  subtitle: {
    fontSize: 13,
    marginTop: 4
  },
  firstItem: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.grey[200],
    padding: 16,
    borderRadius: 12,
    [theme.breakpoints.up('sm')]: {
      gridColumn: '1 / 2',
      height: '100%'
    },
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center'
    }
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
    alignItems: 'center',
    borderLeft: `1px solid ${theme.palette.grey[400]}`,
    [theme.breakpoints.down('sm')]: {
      borderTop: `1px solid ${theme.palette.grey[400]}`
    }
  },
  lastItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      gridColumn: '5 / 6'
    }
  },
  itemsWrapper: {
    [theme.breakpoints.up('sm')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gridColumn: '2 / 5' // ⬅ span only middle columns
    }
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 12
  },
  success: {
    color: theme.palette.secondary.main,
    fontWeight: 500
  },
  failed: {
    color: theme.palette.primary.main,
    fontWeight: 500
  },
  time: {
    marginTop: 4,
    fontSize: 13
  },
  viewAll: {
    fontWeight: 500,
    fontSize: 16,
    color: theme.palette.info.main
  },
  viewAllDisabled: {
    color: theme.palette.grey[400]
  }
}))

export default useStyles
